export default [
  {
    path: '/supplierMaintenance',
    meta: {
      isNoNeedToLogin: true
    },
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: 'login',
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none'
        },
        component: () => import('@/views/SupplierMaintenance/SupplierMaintenanceLogin.vue')
      },
      {
        path: 'list',
        name: 'supplierMaintenanceList',
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none'
        },
        component: () => import('@/views/SupplierMaintenance/SupplierMaintenanceList.vue')
      },
      {
        path: '401',
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none'
        },
        component: () => import('@/views/SupplierMaintenance/SupplierMaintenance401.vue')
      },
      {
        path: '*',
        meta: {
          header: 'none',
          footer: 'none',
          logoutinfo: 'none'
        },
        redirect: '401'
      }
    ]
  }
]
